import { PocketPickLogScreen } from '@/screens/pocketPick/PocketPickLogScreen'

export default function () {
  return <PocketPickLogScreen />
}
